export const groundwaterConservationDistrictsFill = {
  id: "groundwater-conservation-districts-fill",
  name: "GW Conservation Districts",
  type: "fill",
  source: "groundwater-conservation-districts",
  "source-layer": "GCD_Shapefiles-7gqw1a",
  paint: {
    "fill-color": [
      "match",
      ["get", "SHORTNAM"],
      ["Bandera County River Authority & Ground Water District"],
      "#520100",
      ["Barton Springs/Edwards Aquifer CD"],
      "#ffc396",
      ["Bee GCD"],
      "#00ffff",
      ["Blanco-Pedernales GCD"],
      "#990000",
      ["Bluebonnet GCD"],
      "#770001",
      ["Brazoria County GCD"],
      "#651ba1",
      ["Brazos Valley GCD"],
      "#00ff90",
      ["Brewster County GCD"],
      "#7b00e4",
      ["Brush Country GCD"],
      "#195b00",
      ["Calhoun County GCD"],
      "#cdb571",
      ["Central Texas GCD"],
      "#003800",
      ["Clear Fork GCD"],
      "#e2ff5c",
      ["Clearwater UWCD"],
      "#00dbff",
      ["Coastal Bend GCD"],
      "#ebffdc",
      ["Coastal Plains GCD"],
      "#00d977",
      ["Coke County UWCD"],
      "#8f0000",
      ["Colorado County GCD"],
      "#00645e",
      ["Comal Trinity GCD"],
      "#005a6d",
      ["Corpus Christi ASRCD"],
      "#c7b1ff",
      ["Cow Creek GCD"],
      "#e4ffa2",
      ["Crockett County GCD"],
      "#00d0ff",
      ["Culberson County GCD"],
      "#001914",
      ["Duval County GCD"],
      "#ffa2ae",
      ["Edwards Aquifer Authority"],
      "#ffb2e1",
      ["Evergreen UWCD"],
      "#de3cd5",
      ["Fayette County GCD"],
      "#00ff43",
      ["Fort Bend Subsidence District"],
      "#ff9200",
      ["Garza County UWCD"],
      "#ffa5f4",
      ["Gateway GCD"],
      "#ff9f2d",
      ["Glasscock GCD"],
      "#00da9d",
      ["Goliad County GCD"],
      "#00ff75",
      ["Gonzales County UWCD"],
      "#1e0300",
      ["Guadalupe County GCD"],
      "#fdefdd",
      ["Harris-Galveston Coastal Subsidence District"],
      "#4d4d22",
      ["Hays Trinity GCD"],
      "#670000",
      ["Headwaters UWCD"],
      "#0095ff",
      ["Hemphill County UWCD"],
      "#004faa",
      ["Hickory UWCD No. 1"],
      "#4c3100",
      ["High Plains UWCD No.1"],
      "#99005b",
      ["Hill Country UWCD"],
      "#4f920a",
      ["Hudspeth County UWCD No. 1"],
      "#5a7700",
      ["Irion County WCD"],
      "#e76451",
      ["Jeff Davis County UWCD"],
      "#005e85",
      ["Kenedy County GCD"],
      "#ffa0ff",
      ["Kimble County GCD"],
      "#621200",
      ["Kinney County GCD"],
      "#ff76ff",
      ["Lavaca (P)"],
      "#C49C94",
      ["Lipan-Kickapoo WCD"],
      "#7f4e5a",
      ["Llano Estacado UWCD"],
      "#5c8400",
      ["Lone Star GCD"],
      "#009021",
      ["Lone Wolf GCD"],
      "#1c0957",
      ["Lost Pines GCD"],
      "#bbbe00",
      ["Lower Trinity GCD"],
      "#004d74",
      ["McMullen GCD"],
      "#9b7bff",
      ["Medina County GCD"],
      "#580000",
      ["Menard County UWCD"],
      "#7a0000",
      ["Mesa UWCD"],
      "#6f9b00",
      ["Mesquite GCD"],
      "#00414b",
      ["Mid-East Texas GCD"],
      "#610000",
      ["Middle Pecos GCD"],
      "#a800d1",
      ["Middle Trinity GCD"],
      "#003076",
      ["Neches & Trinity Valleys GCD"],
      "#00bdb5",
      ["North Plains GCD"],
      "#00276b",
      ["North Texas GCD"],
      "#ff81cc",
      ["Northern Trinity GCD"],
      "#ff70fd",
      ["Panhandle GCD"],
      "#026f53",
      ["Panola County GCD"],
      "#d1526a",
      ["Pecan Valley GCD"],
      "#0075ff",
      ["Permian Basin UWCD"],
      "#8c0000",
      ["Pineywoods GCD"],
      "#002da7",
      ["Plum Creek CD"],
      "#c65a30",
      ["Post Oak Savannah GCD"],
      "#0ca200",
      ["Presidio County UWCD"],
      "#850077",
      ["Real-Edwards C and R District"],
      "#00ff00",
      ["Red River GCD"],
      "#7b8000",
      ["Red Sands GCD"],
      "#d93400",
      ["Refugio GCD"],
      "#00168e",
      ["Rolling Plains GCD"],
      "#620034",
      ["Rusk County GCD"],
      "#94effa",
      ["San Patricio County GCD"],
      "#da3f6c",
      ["Santa Rita UWCD"],
      "#0062a5",
      ["Sandy Land UWCD"],
      "#00dd99",
      ["Saratoga UWCD"],
      "#840069",
      ["South Plains UWCD"],
      "#6d7300",
      ["South Central Texas (L)"],
      "#8C564B",
      ["Southern Trinity GCD"],
      "#a8d968",
      ["Southwestern Travis County GCD"],
      "#657e54",
      ["Starr County GCD"],
      "#ffc1ff",
      ["Sterling County UWCD"],
      "#ff665c",
      ["Sutton County UWCD"],
      "#710000",
      ["Texana GCD"],
      "#9df800",
      ["Terrell County GCD"],
      "#8e0043",
      ["Trinity Glen Rose GCD"],
      "#00a2c0",
      ["Uvalde County UWCD"],
      "#0073d8",
      ["Victoria County GCD"],
      "#00ffff",
      ["Wes-Tex GCD"],
      "#009517",
      ["Wintergarden GCD"],
      "#ff75ff",
      "black",
    ],
    "fill-opacity": 0.25,
  },
  layout: {
    visibility: "none",
  },
};

export const groundwaterConservationDistrictsLine = {
  id: "groundwater-conservation-districts-line",
  name: "GW Conservation Districts",
  type: "line",
  source: "groundwater-conservation-districts",
  "source-layer": "GCD_Shapefiles-7gqw1a",
  paint: {
    "line-color": [
      "match",
      ["get", "SHORTNAM"],
      ["Bandera County River Authority & Ground Water District"],
      "#520100",
      ["Barton Springs/Edwards Aquifer CD"],
      "#ffc396",
      ["Bee GCD"],
      "#00ffff",
      ["Blanco-Pedernales GCD"],
      "#990000",
      ["Bluebonnet GCD"],
      "#770001",
      ["Brazoria County GCD"],
      "#651ba1",
      ["Brazos Valley GCD"],
      "#00ff90",
      ["Brewster County GCD"],
      "#7b00e4",
      ["Brush Country GCD"],
      "#195b00",
      ["Calhoun County GCD"],
      "#cdb571",
      ["Central Texas GCD"],
      "#003800",
      ["Clear Fork GCD"],
      "#e2ff5c",
      ["Clearwater UWCD"],
      "#00dbff",
      ["Coastal Bend GCD"],
      "#ebffdc",
      ["Coastal Plains GCD"],
      "#00d977",
      ["Coke County UWCD"],
      "#8f0000",
      ["Colorado County GCD"],
      "#00645e",
      ["Comal Trinity GCD"],
      "#005a6d",
      ["Corpus Christi ASRCD"],
      "#c7b1ff",
      ["Cow Creek GCD"],
      "#e4ffa2",
      ["Crockett County GCD"],
      "#00d0ff",
      ["Culberson County GCD"],
      "#001914",
      ["Duval County GCD"],
      "#ffa2ae",
      ["Edwards Aquifer Authority"],
      "#ffb2e1",
      ["Evergreen UWCD"],
      "#de3cd5",
      ["Fayette County GCD"],
      "#00ff43",
      ["Fort Bend Subsidence District"],
      "#ff9200",
      ["Garza County UWCD"],
      "#ffa5f4",
      ["Gateway GCD"],
      "#ff9f2d",
      ["Glasscock GCD"],
      "#00da9d",
      ["Goliad County GCD"],
      "#00ff75",
      ["Gonzales County UWCD"],
      "#1e0300",
      ["Guadalupe County GCD"],
      "#fdefdd",
      ["Harris-Galveston Coastal Subsidence District"],
      "#4d4d22",
      ["Hays Trinity GCD"],
      "#670000",
      ["Headwaters UWCD"],
      "#0095ff",
      ["Hemphill County UWCD"],
      "#004faa",
      ["Hickory UWCD No. 1"],
      "#4c3100",
      ["High Plains UWCD No.1"],
      "#99005b",
      ["Hill Country UWCD"],
      "#4f920a",
      ["Hudspeth County UWCD No. 1"],
      "#5a7700",
      ["Irion County WCD"],
      "#e76451",
      ["Jeff Davis County UWCD"],
      "#005e85",
      ["Kenedy County GCD"],
      "#ffa0ff",
      ["Kimble County GCD"],
      "#621200",
      ["Kinney County GCD"],
      "#ff76ff",
      ["Lavaca (P)"],
      "#C49C94",
      ["Lipan-Kickapoo WCD"],
      "#7f4e5a",
      ["Llano Estacado UWCD"],
      "#5c8400",
      ["Lone Star GCD"],
      "#009021",
      ["Lone Wolf GCD"],
      "#1c0957",
      ["Lost Pines GCD"],
      "#bbbe00",
      ["Lower Trinity GCD"],
      "#004d74",
      ["McMullen GCD"],
      "#9b7bff",
      ["Medina County GCD"],
      "#580000",
      ["Menard County UWCD"],
      "#7a0000",
      ["Mesa UWCD"],
      "#6f9b00",
      ["Mesquite GCD"],
      "#00414b",
      ["Mid-East Texas GCD"],
      "#610000",
      ["Middle Pecos GCD"],
      "#a800d1",
      ["Middle Trinity GCD"],
      "#003076",
      ["Neches & Trinity Valleys GCD"],
      "#00bdb5",
      ["North Plains GCD"],
      "#00276b",
      ["North Texas GCD"],
      "#ff81cc",
      ["Northern Trinity GCD"],
      "#ff70fd",
      ["Panhandle GCD"],
      "#026f53",
      ["Panola County GCD"],
      "#d1526a",
      ["Pecan Valley GCD"],
      "#0075ff",
      ["Permian Basin UWCD"],
      "#8c0000",
      ["Pineywoods GCD"],
      "#002da7",
      ["Plum Creek CD"],
      "#c65a30",
      ["Post Oak Savannah GCD"],
      "#0ca200",
      ["Presidio County UWCD"],
      "#850077",
      ["Real-Edwards C and R District"],
      "#00ff00",
      ["Red River GCD"],
      "#7b8000",
      ["Red Sands GCD"],
      "#d93400",
      ["Refugio GCD"],
      "#00168e",
      ["Rolling Plains GCD"],
      "#620034",
      ["Rusk County GCD"],
      "#94effa",
      ["San Patricio County GCD"],
      "#da3f6c",
      ["Santa Rita UWCD"],
      "#0062a5",
      ["Sandy Land UWCD"],
      "#00dd99",
      ["Saratoga UWCD"],
      "#840069",
      ["South Plains UWCD"],
      "#6d7300",
      ["South Central Texas (L)"],
      "#8C564B",
      ["Southern Trinity GCD"],
      "#a8d968",
      ["Southwestern Travis County GCD"],
      "#657e54",
      ["Starr County GCD"],
      "#ffc1ff",
      ["Sterling County UWCD"],
      "#ff665c",
      ["Sutton County UWCD"],
      "#710000",
      ["Texana GCD"],
      "#9df800",
      ["Terrell County GCD"],
      "#8e0043",
      ["Trinity Glen Rose GCD"],
      "#00a2c0",
      ["Uvalde County UWCD"],
      "#0073d8",
      ["Victoria County GCD"],
      "#00ffff",
      ["Wes-Tex GCD"],
      "#009517",
      ["Wintergarden GCD"],
      "#ff75ff",
      "black",
    ],
    "line-width": 4,
  },
  layout: {
    visibility: "none",
  },
};

export const groundwaterConservationDistrictsSymbol = {
  id: "groundwater-conservation-districts-symbol",
  name: "GW Conservation Districts",
  type: "symbol",
  source: "groundwater-conservation-districts",
  "source-layer": "GCD_Shapefiles-7gqw1a",
  layout: {
    "symbol-placement": "point",
    "text-field": ["get", "SHORTNAM"],
    "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
    "text-size": 14,
    "text-anchor": "center",
    "text-offset": [0, -1.5],
    "text-justify": "center",
    "text-max-width": 8,
    visibility: "none",
  },
  paint: {
    "text-color": "#1a1a1a",
    "text-halo-color": "rgba(255, 255, 255, 0.9)",
    "text-halo-width": 2,
    "text-halo-blur": 0.1,
  },
};
